import { call } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga/effects';

import { types as invoiceLineTypes, actions as invoiceLineActions } from 'ducks/salesInvoiceEnquiry/InvoiceLineBOM';

import { callApi } from '../utils';
import * as api from 'api/salesInvoiceEnquiry/invoiceLineBOM';

function* getComponentDetails(action) {
  const { success, failure } = invoiceLineActions.saga.fetchComponentDetails;
  yield callApi(
    call(api.getComponentDetails, action.data),
    success,
    failure
  )
}

export default function* rootCustomerSaga() {
  yield takeLatest(invoiceLineTypes.fetchComponentDetails, getComponentDetails)
}